import { render, staticRenderFns } from "./ItemsExtract.vue?vue&type=template&id=03a246a8"
import script from "./ItemsExtract.vue?vue&type=script&lang=js"
export * from "./ItemsExtract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports